<template>
  <table class="org-table">
    <tr>
      <td rowspan="2" colspan="2">目录</td>
      <td colspan="2">单选</td>
      <td colspan="2">多选</td>
      <td colspan="2">问答</td>
    </tr>
    <tr>
      <td>数量</td>
      <td>总分</td>
      <td>数量</td>
      <td>总分</td>
      <td>数量</td>
      <td>总分</td>
    </tr>
    <tr>
      <td colspan="2">共计</td>
      <td>{{showData.single.number}}</td>
      <td>{{showData.single.score}}</td>
      <td>{{showData.muitible.number}}</td>
      <td>{{showData.muitible.score}}</td>
      <td>{{showData.answer.number}}</td>
      <td>{{showData.answer.score}}</td>
    </tr>
    <tr>
      <td rowspan="2">总计</td>
      <td>数量</td>
      <td colspan="6">{{showData.single.number + showData.muitible.number + showData.answer.number}}</td>
    </tr>
    <tr>
      <td>总分数</td>
      <td colspan="6">{{showData.single.score + showData.muitible.score + showData.answer.score}}</td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'score-table',
  props: ['questionItems'],
  data() {
    return {
      showData: {
        single: {
          number: 0,
          score: 0
        },
        muitible: {
          number: 0,
          score: 0
        },
        answer: {
          number: 0,
          score: 0
        }
      }
    }
  },
  created() {
    // 这里进行数据的计算
    if (this.questionItems && this.questionItems.length > 0) {
      this.questionItems.forEach(item => {
        if (!item.score) {
          item.score = 0
        }
        if (item.type === 0) {
          this.showData.single.number += (item.num || 1)
          this.showData.single.score += item.score * 1
        }
        if (item.type === 1) {
          this.showData.muitible.number += (item.num || 1)
          this.showData.muitible.score += item.score * 1
        }
        if (item.type === 2) {
          this.showData.answer.number += (item.num || 1)
          this.showData.answer.score += item.score * 1
        }
      })
    }
  },
  watch: {
    questionItems: {
      deep: true,
      handler(newValue, oldValue) {
        this.showData.single.number = 0
        this.showData.single.score = 0
        this.showData.muitible.number = 0
        this.showData.muitible.score = 0
        this.showData.answer.number = 0
        this.showData.answer.score = 0
        // 这里进行数据的计算
        newValue.forEach(item => {
          if (!item.score) {
            item.score = 0
          }
          if (item.type === 0) {
            this.showData.single.number += (item.num || 1)
            this.showData.single.score += item.score * 1
          }
          if (item.type === 1) {
            this.showData.muitible.number += (item.num || 1)
            this.showData.muitible.score += item.score * 1
          }
          if (item.type === 2) {
            this.showData.answer.number += (item.num || 1)
            this.showData.answer.score += item.score * 1
          }
        })
      }
    }
  }
}

</script>
<style scoped lang="scss">
.org-table {
  border: 1px solid #dddddd;
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;

  tr {
    height: 30px;
    &:nth-child(-n+2) {
      background: #f3f7f9;
    }

    td {
      border: 1px solid #dddddd;
      text-align: center;
      height: 30px !important;
      padding: 0;
    }
  }
}

</style>
